module.exports = __webpack_public_path__ + "img/rupiah-sign.ec9ac0c5.svg";